import { Flex, Text } from '@chakra-ui/react'
import { User } from 'brokertslib/src/dtos'

import { EmailAddress } from '../shared/EmailAddress'
import { OrganizationLink } from '../shared/OrganizationLink'
import { UserLink } from '../shared/UserLink'

export const InsuranceInfoBroker = ({
  broker,
  date,
}: {
  broker?: User
  date: Date
}) => {
  let createdName = broker?.name ?? ''
  if (broker?.surname) {
    createdName = `${createdName} ${broker.surname}`.trim()
  }

  return (
    <Flex sx={{ fontSize: 'sm', fontWeight: 'medium' }}>
      <Text sx={{ fontWeight: 'semibold' }} as="span">
        Nabídku zpracoval(a):&nbsp;
      </Text>
      {broker && (
        <UserLink
          name={createdName}
          userId={broker.userId}
          sx={{ color: 'blue.600' }}
        />
      )}
      ,&nbsp;
      {broker && (
        <OrganizationLink
          name={broker?.ouName}
          id={broker?.ouId}
          sx={{ color: 'blue.600' }}
        />
      )}
      ,&nbsp;
      {broker?.email && (
        <EmailAddress
          email={broker.email}
          showIcon={false}
          sx={{ color: 'blue.600' }}
        />
      )}
      ,
      <Text as="span">
        &nbsp;
        {Intl.DateTimeFormat('cs-CZ', {
          dateStyle: 'medium',
          timeStyle: 'medium',
        }).format(date)}
      </Text>
    </Flex>
  )
}
